import type { Dispatch } from 'redux'

import { user } from '@fireflyhealth/api'

import { queueNotification } from '~/shared/notifications/actions'
import { patientsSlice } from './patientsSlice'
import { logger } from '~/shared/lib/logger'

export const getPatient = (patientId: number | string) => {
  return async (dispatch: Dispatch) => {
    try {
      const { data } = await user.retrieve({ id: String(patientId) })
      if (!data.is_patient) throw new Error('User is not a patient')
      return dispatch(patientsSlice.actions.getPatientSuccess(data))
    } catch (error) {
      if (error instanceof Error) {
        logger.error('[Patient] fetch patient', error)
        dispatch(patientsSlice.actions.getPatientError())
        const err = new Error(
          `'Problem fetching patient for id: ${patientId}. Error: ${error.message}`,
        )
        err.stack = error.stack
        throw err
      }
    }
  }
}

export const updatePatient =
  (payload: Record<string, unknown> & { id: number | string }) => async (dispatch: Dispatch) => {
    try {
      const { id, ...body } = payload
      const { data } = await user.partialUpdate({ id: String(id) }, { data: body })
      dispatch(patientsSlice.actions.getPatientSuccess(data))
      dispatch(
        queueNotification({
          variant: 'success',
          message: 'Patient info updated',
        }),
      )
    } catch (e) {
      logger.warn('[Patient] update patient', e)
      dispatch(queueNotification({ variant: 'error', message: 'Problem updating patient info' }))
      throw new Error('Problem updating patient info')
    }
  }
